export default {
  bot: 'Bot',
  attendents: 'Attendants',
  teams: 'Teams',
  tags: 'Tags',
  closedTickets: 'Closed Tickets',
  averageFirstResponseTime: 'Average First Response Time',
  averageWaitTime: 'Average Wait Time',
  averageResponseTime: 'Average Response Time',
  averageAttendanceTime: 'Average Attendance Time',
};
